import { type ReactNode, createContext, useCallback, useContext, useMemo, useState } from 'react';

interface CustomFontContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const CustomFontContext = createContext<CustomFontContextType | undefined>(undefined);

interface CustomFontProviderProps {
  children: ReactNode;
}

export const CustomFontProvider = ({ children }: CustomFontProviderProps) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  const contextValue = useMemo(() => ({ refreshTrigger, triggerRefresh }), [refreshTrigger, triggerRefresh]);

  return <CustomFontContext.Provider value={contextValue}>{children}</CustomFontContext.Provider>;
};

export const useCustomFontContext = () => {
  const context = useContext(CustomFontContext);
  if (context === undefined) {
    // Return a fallback context when provider is not available
    return {
      refreshTrigger: 0,
      triggerRefresh: () => {}, // No-op function
    };
  }
  return context;
};
